// Provider "draft is already gone" messages. Matched case-insensitively
// (both sides lower-cased) against the error text. Gmail: "Requested entity
// was not found."; Outlook Graph: "ErrorItemNotFound" / "The specified
// object was not found in the store."
export const DRAFT_NOT_FOUND_ERROR_PATTERNS = [
  'not found',
  'notfound',
  'ErrorItemNotFound',
];
